import React from 'react';
import { motion } from 'framer-motion';
export function EliteComparison() {
  const comparisons = [{
    situation: 'Leer una RX o RMN',
    base: 'Dependés del radiólogo',
    elite: 'Lo hacés vos solo'
  }, {
    situation: 'Emergencia en consultorio',
    base: 'No sabés qué hacer',
    elite: 'Protocolo claro listo'
  }, {
    situation: 'Hablar con el traumatólogo',
    base: 'Lenguaje básico',
    elite: 'Vocabulario técnico pro'
  }, {
    situation: 'Documentación legal',
    base: 'Sin criterio legal',
    elite: 'Blindaje legal total'
  }, {
    situation: 'Banderas rojas en guardia',
    base: 'Las aprendés de casualidad',
    elite: 'Checklist listo y claro'
  }, {
    situation: 'Tu matrícula',
    base: 'Riesgo real',
    elite: '100% protegida'
  }];
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-47">
      <div className="max-w-5xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-50">
            ¿Qué agrega la versión Élite?
          </h2>
          <p className="text-xl text-slate-700 max-w-3xl mx-auto" data-id="element-51">
            Todo lo del Rescate Base, más 2 Ebooks de Autoridad Clínica para
            brillar donde otros estudiantes se quedan sin respuestas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl shadow-lg overflow-hidden border border-slate-200" data-id="element-52">
          <table className="w-full table-fixed" data-id="element-53">
            <thead data-id="element-54">
              <tr className="bg-slate-900 text-white" data-id="element-55">
                <th className="w-1/3 px-2 sm:px-4 md:px-6 py-3 md:py-4 text-left font-bold text-xs sm:text-sm md:text-base break-words" data-id="element-56">
                  Situación
                </th>
                <th className="w-1/3 px-2 sm:px-4 md:px-6 py-3 md:py-4 text-center font-bold text-xs sm:text-sm md:text-base" data-id="element-57">
                  Base
                </th>
                <th className="w-1/3 px-2 sm:px-4 md:px-6 py-3 md:py-4 text-center font-bold bg-[#F0C040] text-slate-900 text-xs sm:text-sm md:text-base" data-id="element-58">
                  Élite
                </th>
              </tr>
            </thead>
            <tbody data-id="element-59">
              {comparisons.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-slate-50' : 'bg-white'} data-id="element-60">
                  <td className="px-2 sm:px-4 md:px-6 py-3 md:py-4 font-medium text-slate-900 text-xs sm:text-sm md:text-base break-words" data-id="element-61">
                    {row.situation}
                  </td>
                  <td className="px-2 sm:px-4 md:px-6 py-3 md:py-4 text-center text-slate-600 text-xs sm:text-sm md:text-base break-words" data-id="element-62">
                    {row.base}
                  </td>
                  <td className="px-2 sm:px-4 md:px-6 py-3 md:py-4 text-center font-semibold text-green-700 text-xs sm:text-sm md:text-base break-words" data-id="element-63">
                    {row.elite}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}